import React, { Children, FunctionComponent, isValidElement } from 'react';

import { captureException } from '@sentry/browser';

import { Variation as VariationType } from '../../utils/abTests';

// Prop is used in the Experiment component
interface VariationProps {
  name: VariationType;
}

export const Variation: FunctionComponent<VariationProps> = ({ children }) => {
  if (Children.count(children) > 1) {
    const message = 'Variation only accepts a single child';
    captureException(message);
    throw new Error(message);
  }

  if (!isValidElement(children)) {
    const message = 'Variation only accepts valid react elements';
    captureException(message);
    throw new Error(message);
  }

  return children;
};

Variation.displayName = 'Variation';
